import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-staffassignments',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    TranslateDirective
  ],
  templateUrl: './staffclasslist.component.html',
  styleUrls: ['./staffclasslist.component.scss'],
})
export class StaffassignmentsComponent {
  selectedReg: string = '';
  userData: any;

  classes = [
    {
      id: 1,
      title: 'MPC - 3rd Sem',
      reg: '2023 - 2026',
      medium: 'English Medium',
      section: 'A Sec',
      subject: 'Mathematics',
    },
    {
      id: 2,
      title: 'MPC - 1st Sem',
      reg: '2024 - 2027',
      medium: 'English Medium',
      section: 'B Sec',
      subject: 'Physics',
    },
    {
      id: 3,
      title: 'MPC - 5th Sem',
      reg: '2022 - 2025',
      medium: 'English Medium',
      section: 'C Sec',
      subject: 'Chemistry',
    },
    {
      id: 4,
      title: 'MEC - 1st Sem',
      reg: '2023 - 2026',
      medium: 'English Medium',
      section: 'A Sec',
      subject: 'Biology',
    },
    {
      id: 5,
      title: 'MPC - 7th Sem',
      reg: '2023 - 2026',
      medium: 'English Medium',
      section: 'B Sec',
      subject: 'Computer Science',
    },
    {
      id: 6,
      title: 'MPC - 8th Sem',
      reg: '2023 - 2026',
      medium: 'English Medium',
      section: 'C Sec',
      subject: 'Statistics',
    },
    {
      id: 7,
      title: 'MPC - 9th Sem',
      reg: '2023 - 2026',
      medium: 'English Medium',
      section: 'A Sec',
      subject: 'Economics',
    },
    {
      id: 8,
      title: 'MPC - 10th Sem',
      reg: '2023 - 2026',
      medium: 'English Medium',
      section: 'A Sec',
      subject: 'Environmental Science',
    },
  ];

  // Unique reg options
  regs = Array.from(new Set(this.classes.map((c) => c.reg)));

  constructor(private router: Router) {
    const userJson = sessionStorage.getItem('user');
    if (userJson) {
      try {
        this.userData = JSON.parse(userJson);
      } catch (e) {
        console.error('Could not parse user data from session storage', e);
      }
    }
  }

  navigateTo(classData: any) {
    this.router.navigate([
      `/assignments/staff/${this.userData.data.id}/${classData.id}`,
    ]);
  }

  // Filter classes based on selected reg
  filteredClasses() {
    if (!this.selectedReg) return this.classes;
    return this.classes.filter((c) => c.reg === this.selectedReg);
  }
}
